var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FCFBFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_22803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 28.5H15C13.6192 28.5 12.5 27.3809 12.5 26V19.3334C12.5 17.9525 13.6192 16.8334 15 16.8334H25C26.3808 16.8334 27.5 17.9525 27.5 19.3334V26C27.5 27.3809 26.3808 28.5 25 28.5Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 16.8334C16.6667 14.9925 18.1592 13.5 20 13.5C21.8408 13.5 23.3333 14.9925 23.3333 16.8334H25C25 14.0717 22.7617 11.8334 20 11.8334C17.2383 11.8334 15 14.0717 15 16.8334H16.6667Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 23.9166C20.6904 23.9166 21.25 23.357 21.25 22.6666C21.25 21.9763 20.6904 21.4166 20 21.4166C19.3096 21.4166 18.75 21.9763 18.75 22.6666C18.75 23.357 19.3096 23.9166 20 23.9166Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1665 23.9166C24.8569 23.9166 25.4165 23.357 25.4165 22.6666C25.4165 21.9763 24.8569 21.4166 24.1665 21.4166C23.4761 21.4166 22.9165 21.9763 22.9165 22.6666C22.9165 23.357 23.4761 23.9166 24.1665 23.9166Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 23.9166C16.5239 23.9166 17.0835 23.357 17.0835 22.6666C17.0835 21.9763 16.5239 21.4166 15.8335 21.4166C15.1431 21.4166 14.5835 21.9763 14.5835 22.6666C14.5835 23.357 15.1431 23.9166 15.8335 23.9166Z",
    fill: "#6C6C6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_22803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/testIcon.4371b8d98fd0ab9446af422549ef5215.svg";
export { ForwardRef as ReactComponent };